module.exports = __webpack_public_path__ + "assets/img/e6d3b54d71b486dee6f8334910b7063f.png";